import React, { useContext } from "react";
import { Label } from "structure/Document";
import { ContextCatalogueAdmin } from "../..";

/**
 * Render description input
 * @param {import("../types").DescriptionProps} props - Props
 * @returns {JSX.Element}
 */
export default function Description(props) {
  const hook = useContext(ContextCatalogueAdmin);

  const reactHookForm =
    props.operation === "add" ? hook.formAdd : hook.formEdit;

  return (
    <div>
      <Label>Descripción</Label>
      <input
        ref={reactHookForm.register}
        type="text"
        name="description"
        placeholder="Escribe aquí"
        {...props}
      />
      <p className="text-danger font-weight-bold">
        {reactHookForm.errors?.description?.message}
      </p>
    </div>
  );
}
